export enum LinkActionType {
  CONFIRM_ENTRY = 'CONFIRM_ENTRY',
  // UPDATE_CBP_ADDRESS = 'UPDATE_CBP_ADDRESS',
  // UPDATE_INLT_ADDRESS = 'UPDATE_INLT_ADDRESS',
}
